import React from 'react';
import EdenredTypo from '@sharedComponent/typography';
import SelectDropdown from '@pages/DesignSystem/ComboBox/SelectDropdown';
import { options4 } from '@pages/DesignSystem/Json/DesignSystem';
import '../SelectDropdown.scss';

const SubmenuCustomisation = () => {
	return (
		<div style={{ width: '50%', paddingTop: '10px' }}>
			<EdenredTypo h2 bold style={{ fontSize: '18px' }}>
				Options Without Subname , Submenu Without SubName, Both Without SubName
			</EdenredTypo>
			<SelectDropdown
				className="select-dropdown-without-placeholder"
				onChange={(data) => console.log('datass', data)}
				Option={options4}
				placeholder="Sub Menu Options"
				searchVisibility={false}
			/>
		</div>
	);
};

export default SubmenuCustomisation;
